module.exports = __webpack_public_path__ + "static/media/clear-filters.06099872.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/assets/toolbar/clear-filters.svg
// module id = 292
// module chunks = 0